var React = require('react');

function Tram (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M511.45 51.9a15.91 15.91 0 0 0-19.6-11.3l-480 128A16 16 0 0 0 16 200a18.41 18.41 0 0 0 4.1-.5l480-128a16.1 16.1 0 0 0 11.35-19.6zM80 384h96v-96H80zm256 0h96v-96h-96zm-128 0h96v-96h-96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M192 96a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm96-32a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm160 160H272v-91.7l-32 8.5V224H64a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V256a32 32 0 0 0-32-32zM176 384H80v-96h96zm128 0h-96v-96h96zm128 0h-96v-96h96z","className":"fa-primary","key":2})]);
}

Tram.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Tram;

Tram.default = Tram;
